import {
	AuthKeys,
	ListDeliveriesResponse,
	GetDeliveryResponse,
	ResponseWitOutData,
	CreateDeliveryRequest,
	GetListRequest,
} from '../types';
import { fetchData } from '../fetchService';
import { toSearchParams } from '../helpers/common';

const deliveryService = {
	async create(
		baseUrl: string,
		delivery: string,
		data: CreateDeliveryRequest,
		authKeys?: AuthKeys,
	): Promise<ResponseWitOutData> {
		return await fetchData(
			`${baseUrl}/delivery?delivery=${delivery}`,
			'POST',
			data,
			authKeys,
		);
	},
	async get(
		baseUrl: string,
		delivery: string,
		authKeys?: AuthKeys,
	): Promise<GetDeliveryResponse> {
		return await fetchData(
			`${baseUrl}/delivery?delivery=${delivery}`,
			'GET',
			null,
			authKeys,
		);
	},
	async delete(
		baseUrl: string,
		delivery: string,
		authKeys?: AuthKeys,
	): Promise<ResponseWitOutData> {
		return await fetchData(
			`${baseUrl}/delivery?delivery=${delivery}`,
			'DELETE',
			null,
			authKeys,
		);
	},
	async getList(
		baseUrl: string,
		data?: GetListRequest,
		authKeys?: AuthKeys,
	): Promise<ListDeliveriesResponse> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/delivery/match${query ? `?${query}` : ''}`,
			'GET',
			null,
			authKeys,
		);
	},
};

export default deliveryService;
